import { Tag } from "components/DesignSystem/Tag/Tag";
import { createColumnHelper } from "react-table-8.10.7";
import { Person, PersonRole } from "types/Models/apAutofills";
import { PersonRowAction } from "./PersonRowAction";

const roleLabel = (role: PersonRole) =>
  role.persona_type === "OFFICER"
    ? role.persona_role?.name || role.designation || "Officer"
    : "Director";

const createColumn = createColumnHelper<Person>();

export const nameColumn = createColumn.display({
  id: "name",
  header: "Name",
  size: 26,
  cell: (info) => (
    <div className="t-flex t-flex-col">
      <div className="t-text-text-100">
        {info.row.original.first_name} {info.row.original.last_name}
      </div>
      {info.row.original.email && (
        <div className="t-text-body-sm t-text-text-30">
          {info.row.original.email}
        </div>
      )}
    </div>
  ),
});

export const rolesColumn = (variant: "active" | "former") =>
  createColumn.display({
    id: "role",
    header: "Role",
    size: 30,
    cell: (info) => {
      const roles =
        variant === "active"
          ? info.row.original.roles.filter(
              (role) => role.ap_status === "ACTIVE"
            )
          : info.row.original.roles;
      return (
        <div className="t-flex t-flex-wrap t-gap-1">
          {roles.map((role) => (
            <Tag
              key={role.join_id}
              tagType={variant === "active" ? "purple" : "gray"}
              size="small"
              icon={false}
              rounded
            >
              {roleLabel(role)}
            </Tag>
          ))}
          {variant === "active" &&
            info.row.original.is_authorised_signatory && (
              <Tag tagType="orange" size="small" icon={false} rounded>
                Authorized signatory
              </Tag>
            )}
        </div>
      );
    },
  });

export const countryColumn = createColumn.display({
  id: "country",
  header: "Country",
  size: 20,
  cell: (info) => (
    <div className="t-text-text-60">{info.row.original.country || "-"}</div>
  ),
});

export const statusColumn = (variant: "active" | "former") =>
  createColumn.display({
    id: "status",
    header: "Status",
    size: 15,
    cell: () => (
      <Tag
        tagType={variant === "active" ? "green" : "gray"}
        size="small"
        icon={false}
        rounded
      >
        {variant === "active" ? "Active" : "Former"}
      </Tag>
    ),
  });

export const createActionColumn = ({
  onViewDetails,
  onEdit,
}: {
  onViewDetails: (person: Person) => void;
  onEdit: (person: Person) => void;
}) =>
  createColumn.display({
    id: "actions",
    header: "",
    size: 5,
    cell: (info) => (
      <PersonRowAction
        person={info.row.original}
        onViewDetails={onViewDetails}
        onEdit={onEdit}
      />
    ),
  });
